import { getRequest } from './base';

export const getOrganizations = async () => {
  const response = await getRequest('organizations/getfirstlevel');
  if (response.status === 200) {
    return response.data;
  }
  return Promise.reject(response.statusText);
};
